/**
 * isMobileDevice — shared mobile-width detection used by the auto-redirect
 * (App.js MobileRedirect) and the highlights CTA button.
 *
 * Three-signal approach:
 *   1. window.innerWidth / matchMedia  — correct for normal mobile browsers
 *   2. screen.width + UA               — fallback for "Request Desktop Site" mode,
 *      which overrides the viewport (innerWidth → ~1280) but not screen.width
 */
const BREAKPOINT = 900;

export function isMobileDevice() {
  const narrowViewport =
    window.innerWidth < BREAKPOINT ||
    window.matchMedia(`(max-width: ${BREAKPOINT - 1}px)`).matches;
  const mobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const narrowScreen = window.screen.width < BREAKPOINT;
  return narrowViewport || (mobileUA && narrowScreen);
}

/**
 * shouldGoMobile — returns true when the auto-redirect would fire.
 * Checks both device width AND the preferDesktop opt-out flag.
 * Use this to decide whether a navigation button should go to /m or /explore.
 */
export function shouldGoMobile() {
  return isMobileDevice() && localStorage.getItem("preferDesktop") !== "true";
}
